import { useMemo } from "react";

import { Grid, Paper, Typography } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";

import { UserOutletsSelect } from "@/features/outlets";
import { CustomDatePicker, CustomInputField } from "@/features/ui";

export const GeneralInformationSection = () => {
  const {
    control,
    register,
    watch,
    formState: { errors },
  } = useFormContext();

  const transactions = watch("outletChartOfAccountTransactions");

  // Disable outlet selection if any account is selected
  const hasSelectedAccounts = useMemo(() => {
    return transactions?.some((t) => t.outletChartOfAccount !== null);
  }, [transactions]);

  return (
    <Paper sx={{ p: 3, borderRadius: 2 }}>
      <Typography variant="h6" gutterBottom>
        Informasi Umum
      </Typography>

      <Grid container spacing={3}>
        {/* Cabang */}
        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
          <Controller
            name="outlet"
            control={control}
            render={({ field, fieldState }) => (
              <UserOutletsSelect
                {...field}
                disabled={hasSelectedAccounts}
                TextFieldProps={{
                  required: true,
                  label: "Cabang",
                  error: fieldState.invalid,
                  helperText: hasSelectedAccounts
                    ? "Tidak dapat mengubah cabang karena sudah memilih akun"
                    : fieldState.error?.message,
                }}
              />
            )}
          />
        </Grid>

        {/* Tanggal Transaksi */}
        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
          <Controller
            name="transactionDate"
            control={control}
            render={({ field, fieldState }) => (
              <CustomDatePicker
                value={field.value}
                onChange={field.onChange}
                required
                label="Tanggal Transaksi"
                error={fieldState.invalid}
                helperText={fieldState.error?.message}
                InputProps={{
                  disableFuture: true,
                }}
              />
            )}
          />
        </Grid>

        {/* Catatan */}
        <Grid size={{ xs: 12, md: 4 }}>
          <CustomInputField
            name="note"
            label="Catatan"
            register={register}
            error={Boolean(errors.note)}
            helperText={errors.note?.message}
          />
        </Grid>
      </Grid>
    </Paper>
  );
};
